export default "__VITE_ASSET___10qGjX4__"